// services/paymentApi.ts
import apiClient from "./apiClient";

export interface Payment {
  id: number;
  customerId: number;
  amount: string;
  paymentType: "cash" | "bank" | "damage";
  paymentDate: string;
  referenceNo?: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  Customer?: {
    id: number;
    fullName: string;
    phone: string;
    balance: string;
  };
  creator?: {
    id: number;
    ownerName: string;
  };
}

export interface CreatePaymentPayload {
  customerId: number;
  amount: number;
  paymentType?: "cash" | "bank" | "damage";
  paymentDate?: string;
  referenceNo?: string;
}

export interface ListPaymentsParams {
  page?: number;
  limit?: number;
  customerId?: number;
  paymentType?: "cash" | "bank" | "damage";
  startDate?: string;
  endDate?: string;
}

export const paymentApi = {
  // Create payment
  create: async (data: CreatePaymentPayload): Promise<{ payment: Payment }> => {
    const response = await apiClient.post("/customer-payments", data);
    return response.data;
  },

  // List payments (with pagination and filters)
  list: async (
    params: ListPaymentsParams,
  ): Promise<{
    payments: Payment[];
    pagination: {
      totalItems: number;
      totalPages: number;
      currentPage: number;
      itemsPerPage: number;
      hasNextPage: boolean;
      hasPrevPage: boolean;
    };
  }> => {
    const response = await apiClient.get("/customer-payments", { params });
    return response.data;
  },

  // Get single payment
  getById: async (id: number): Promise<{ payment: Payment }> => {
    const response = await apiClient.get(`/customer-payments/${id}`);
    return response.data;
  },

  // Delete payment (soft delete, owner only, within 1 hour)
  delete: async (id: number): Promise<{ message: string }> => {
    const response = await apiClient.delete(`/customer-payments/${id}`);
    return response.data;
  },
};
